import { render } from "./ProductPhotos.vue?vue&type=template&id=e8174694"
import script from "./ProductPhotos.vue?vue&type=script&lang=js"
export * from "./ProductPhotos.vue?vue&type=script&lang=js"

import "./ProductPhotos.vue?vue&type=style&index=0&id=e8174694&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__